import pkg from "../package.json";
import { attachChatApiToWindow } from "./namespace";
import { ChatApi } from "./types";

/**
 * Canonical chat widget API object.
 *
 * Internals should read and write this via `getChatApi()`. The public install
 * API attaches the same object to `window[namespace]` at boot.
 */
const chatApi: ChatApi = {
  chat: {
    load: () => {},
    open: () => {},
    close: () => {},
    show: () => {},
    hide: () => {},
    proactive: {
      clear: () => {},
      push: () => {},
    },
    id: "",
    config: {},
    status: "idle",
    test_mode: false,
    version: pkg.version,
  },
  analytics: {
    track: () => {},
  },
};

/** The shared chat widget API. Same object attached to `window[namespace]`. */
export function getChatApi(): ChatApi {
  return chatApi;
}

/** Assign `load` and attach the API to `window[namespace]`. */
export function bindChatApiLoad(load: ChatApi["chat"]["load"]): void {
  chatApi.chat.load = load;
  attachChatApiToWindow(chatApi);
}
